import { render } from "./rework-and-requests-minicard.vue?vue&type=template&id=008a9504"
import script from "./rework-and-requests-minicard.vue?vue&type=script&lang=js"
export * from "./rework-and-requests-minicard.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__